import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { BillingSubscriptionProduct } from './types/Subscriptions';

const getSubscriptionTenantProducts = (makeCall: MakeCall) => () =>
  makeCall<BillingSubscriptionProduct>(
    'GET',
    `/api/v2/billing/subscriptions/tenant-products`,
  );

export default getSubscriptionTenantProducts;
